export default __webpack_public_path__ + "static/media/random-h.5c220c79.jpg";